import OpeningApi from './_openingApi';

class OpeningAccountEntryStatisticAPI extends OpeningApi {
  constructor() {
    super();
  }
  controllerName = 'OpeningAccountEntryStatistics';
}

export default new OpeningAccountEntryStatisticAPI();
